<script>
  import { onMount } from "svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import ViewCardBase from "../../../components/views/cards/ViewCardBase.svelte";
  import Button from "../../../components/button/Button.svelte";
  import DownloadIconButton from "../../../components/IconButtons/DownloadIconButton.svelte";
  import { downloadFile } from "../../../utils/download.js";
  import Breadcrumbs from "../../parts/Breadcrumbs.svelte";

  const autoMpsProjectContext = getAutoMpsProjectContext()
  const projectId = $autoMpsProjectContext.projectId
  const executionId = $autoMpsProjectContext.executionId

  const views = {
    LoadGraph_MPS: {
      iconSrc: "/assets/icons/icon_load_graph_mps.png",
      href: `/auto-mps/projects/${projectId}/executions/${executionId}/views/load-graph`,
      name: {
        ja: "負荷グラフ (MPS)",
      },
    },
    PSIGraph: {
      iconSrc: "/assets/icons/icon_psi_graph.png",
      href: `/auto-mps/projects/${projectId}/executions/${executionId}/views/psi-graph`,
      name: {
        ja: "PSIグラフ",
      },
    },
    PSITable_MPS: {
      iconSrc: "/assets/icons/icon_psi_table_mps.png",
      href: `/auto-mps/projects/${projectId}/executions/${executionId}/views/psi-table`,
      name: {
        ja: "PSI表",
      },
    },
  }

  $: breadcrumbItems = [
    {
      title: "実行一覧",
      href: `/auto-mps/projects/${projectId}/executions`
    },
    {
      title: executionId,
      active: true,
      href: `/auto-mps/projects/${projectId}/executions/${executionId}`
    },
  ]

  let metadata
  async function getPlanData() {
    const response = await fetch(`/api/auto-mps/projects/${projectId}/executions/${executionId}`)
    const data = await response.json()
    metadata = data.meta
  }

  async function onClickDownload() {
    const response = await fetch(`/api/auto-mps/projects/${projectId}/executions/${executionId}/output`)

    downloadFile(await response.blob(), "production_output.csv")
  }

  onMount(async () => {
    await getPlanData()
  })
</script>

<div class="content-root">
  <Breadcrumbs
    items={breadcrumbItems}
  />
  <div style="padding: 1rem; display: flex; justify-content: end; gap: .5rem">
    <Button disabled={true}>
      データをエクスポートする
    </Button>
    <DownloadIconButton disabled={true} onClick={onClickDownload} />
  </div>
  <div id="view-button-cards-container">
    {#each Object.keys(views) as viewName}
      <ViewCardBase
        viewIconSrc={views[viewName].iconSrc}
        href={views[viewName].href}
      >
        <span>{@html views[viewName].name.ja}</span>
      </ViewCardBase>
    {/each}
  </div>
</div>

<style>
  .content-root {
    height: 100%;
    background-color: white;
    padding: 1rem;
  }

  #view-button-cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
  }
</style>
